import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminSponsorsService {
  static TIME_FRAMES = ['ALL', 'LAST_MONTH', 'LAST_YEAR']

  constructor() {
    this.endpoints = {
      ...createPrefix('/admin/sponsor', {
        sponsors: '',
        sponsor: '',
        search: '/search',
      }),

      ...createPrefix('/admin', {
        sponsorUpdate: '/members',
      }),
    }
  }

  static create() {
    return new AdminSponsorsService()
  }

  async querySponsors(params) {
    const servicePath = this.endpoints.search()

    // Create a clean copy of params
    const apiParams = { ...params };

    try {
      const { data } = await axios.get(servicePath, { params: apiParams })
      return data
    } catch (error) {
      // Return empty result to avoid UI crashes
      return {
        content: [],
        totalElements: 0,
        totalPages: 0,
        size: params.size || 10,
        number: params.page || 0,
        empty: true
      };
    }
  }

  async getSponsorById(id) {
    const servicePath = this.endpoints.sponsorUpdate()
    const { data } = await axios.get(`${servicePath}/${id}`)
    return data
  }

  async createSponsor(sponsorDTO) {
    const servicePath = this.endpoints.sponsor()
    const { data } = await axios.post(servicePath, sponsorDTO)
    return data
  }

  async updateMember(member) {
    const servicePath = this.endpoints.sponsorUpdate()
    const { data } = await axios.put(`${servicePath}/${member.id}`, member)
    return data
  }

  async getListOfSports(params) {
    const servicePath = this.endpoints.sponsor()
    const { data } = await axios.post(servicePath, { params })
    return data
  }

  async removeSponsorById(params) {
    const servicePath = this.endpoints.sponsor()
    const { data } = await axios.delete(`${servicePath}/${params}`)
    return data
  }

  async getSponsorInfoById(params) {
    try {
      const { data } = await axios.get(`/sponsor/sponsor/${params}`)
      return data
    } catch (e) {
      // Handle error silently
    }
  }
}
